import React from "react"

const AboutPage = () => {
  return (
    <div className="about-container">
      <h1>About Henna Arts</h1>
      <p>At Henna Arts, we are passionate about creating beautiful henna designs using organic and natural ingredients. Our products are safe, effective, and made with love. Join us on this artistic journey and discover the beauty of henna art.</p>
      <img src="/assets/images/about-us.jpg" alt="About Us" />
    </div>
  )
}

export default AboutPage
